import exportTool from '../pages/tools/export.vue';
import rewardAction from "@/pages/tools/rewardAction.vue";
import notificationEntity from "@/pages/tools/notificationEntity.vue";

const routes = [
  { // /reward-actions/:id
    path: '/reward-actions/:id',
    name: 'reward-action',
    component: rewardAction,
    meta:{
      name: 'Reward Action',
      requireAuth: true
    },
  },
  { // /notification-entity
    path: '/notification-entity',
    name: 'notification-entity',
    component: notificationEntity,
    meta:{
      name: 'Notification Entity',
      requireAuth: true
    },
  },
  { // /reward-actions
    path: '/reward-actions',
    name: 'reward-actions',
    component: rewardAction,
    meta:{
      name: 'Reward Action',
      requireAuth: true
    },
  },
  { // /export/child
    path: '/export/child',
    name: 'export-child',
    component: exportTool,
    meta:{
      name: 'Export Child',
      requireAuth: true
    },
  },
]

export default routes